import { Icon } from '@iconify/react';
import { LinearProgress, linearProgressClasses } from '@mui/material';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { ConnectorStatus } from '../../../@types/boost';
import EvPlugCCS1 from 'assets/EvPlugCCS1';
import { BRAND, GREY } from 'theme/palette';
import { getStatusColor } from 'utils/common';

export const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? `#212B36` : `white`,
  ...theme.typography.body2,
  padding: 0,
  textAlign: 'center',
  color: theme.palette.text.secondary
}));

export const ChargePointLinearProgress = styled(LinearProgress)(() => ({
  height: 8,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: GREY[200]
  },
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: BRAND[100]
  }
}));

export const noPadding = {
  height: '35px',
  paddingTop: 0
};

export const centerFlex = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const background = '#F3F3F3';
export const defaultColor = '#000';

export const flexStart = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center'
};

export const greenColor = '#00D100';

export const mainContainer = {
  background,
  marginTop: '2em'
};

export const sessionProperties = (status: any) => [
  {
    label: `${status === ConnectorStatus.charging ? 'Current' : 'Last'} Session`,
    index: 'session'
  },
  { label: 'Energy Delivered', index: 'energy' },
  { label: `${status === ConnectorStatus.charging ? '' : 'Ending'} Vehicle SOC`, index: 'soc' },
  {
    label: `${status === ConnectorStatus.charging ? '' : 'Max'} Power`,
    index: 'power'
  },
  { label: 'Duration', index: 'duration' },
  { label: 'Revenue', index: 'revenue' }
];

export const getEvPlugIcon = (key: string, type: string, color: string, width: number) => {
  if (key && type && color) {
    return type.toUpperCase() === 'CHADEMO'.toUpperCase() ? (
      <Icon key={key} width={width} icon={'mdi:ev-plug-chademo'} color={color} />
    ) : (
      <EvPlugCCS1 key={key} sx={{ fontSize: width, color }} />
    );
  } else {
    return (
      <Icon
        key={key}
        width={width}
        icon={'mdi:question-mark-circle-outline'}
        color={getStatusColor(ConnectorStatus.unavailable)}
      />
    );
  }
};
